module.exports = __webpack_public_path__ + "static/img/dqkcjsdffx.9ab21dcf.png";